import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { MyBombAmmoDisplay } from '../../../../panels/bombs/myBombAmmoDisplay';
import { PanelHeader } from '../../../../panels/panelHeader';
import { PanelItem } from '../../../../panels/panelItem';
import { PanelContainer } from '../../../../panels/panelStyles';
import { changeNumBombsToThrow } from '../../../../redux/actions/sessionActions';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { BOMBS_PANEL_LIST_BACKGROUND_COLOR, LIGHT_BLUE_COLOR } from '../../../../styles/colors';
import { darkTheme } from '../../../../styles/materialTheme';
import { PANEL_CONTENT_PADDING_STRING } from '../../../../styles/styles';
import { BombsPanelContents } from './bombsPanelContents';
const PAPER_CSS = css `
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: ${BOMBS_PANEL_LIST_BACKGROUND_COLOR} !important;
  padding: 0;
  // Overscroll behavior does weird things on mobile when dragging a bomb, so specifically disable it in this panel:
  // TODO: Consider dynamically adding/removing this style prop as dragging starts or ends.
  overscroll-behavior: none;
`;
export const BombsPanel = () => {
    const dispatch = useAppDispatch();
    const numBombsToThrow = useAppSelector((state) => state.session.numBombsToThrow);
    const onClickBombCount = useCallback(() => {
        dispatch(changeNumBombsToThrow());
    }, [dispatch]);
    return (_jsx(ThemeProvider, { theme: darkTheme, children: _jsxs(PanelContainer, { padding: PANEL_CONTENT_PADDING_STRING, "aria-label": 'bombs panel', children: [_jsx(PanelHeader, { title: 'Bombs & Charms', color: 'white', headerRight: _jsx(Typography, { variant: 'subtitle2', color: LIGHT_BLUE_COLOR, children: "(Drag)" }), gameGuidePageType: 'bombs' }), _jsx(Paper, { component: 'section', css: PAPER_CSS, children: _jsx(BombsPanelContents, {}) }), _jsxs(PanelItem, { flexWrap: true, children: [_jsxs(Button, { onClick: onClickBombCount, variant: 'outlined', size: 'small', title: 'Number To Use', children: [numBombsToThrow, "X"] }), _jsx(MyBombAmmoDisplay, { color: 'white' })] })] }) }));
};
